import { render, staticRenderFns } from "./EducationTargetGroupBlock.vue?vue&type=template&id=88c4cc54"
import script from "./EducationTargetGroupBlock.vue?vue&type=script&lang=js"
export * from "./EducationTargetGroupBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports